var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 11.375C2.31142 11.375 0.875 9.93858 0.875 8.16667C0.875 6.60257 1.99424 5.29989 3.4755 5.01583C4.0327 3.61513 5.40072 2.625 7 2.625C9.00102 2.625 10.64 4.17506 10.7817 6.13994C12.099 6.2805 13.125 7.39543 13.125 8.75C13.125 10.1997 11.9497 11.375 10.5 11.375H4.08333Z",
    stroke: "#1A1A1A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4827a84bcc7cb6384d1910425fdb5d4f.svg";
export { ForwardRef as ReactComponent };